import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { Pageable2 } from "src/app/model/pageable2";
import { PaginatorConfig } from "src/app/model/paginatorConfig";
import { Sender } from "src/app/model/sender";
import { AreaInsertByGeoJsonComponent } from "./area-insert-by-geo-json/area-insert-by-geo-json.component";
import { AreaInsertByGeojsonRequest } from "./area-insert-by-geojson-request";
import { AreaMapDialogComponent } from "./area-map-dialog/area-map-dialog.component";

@Component({
  selector: "app-show-areas",
  templateUrl: "./show-areas.component.html",
  styleUrls: ["./show-areas.component.scss"],
})
export class ShowAreasComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  loading = false;
  sub = false;
  emptyList = false;
  filterValue = "";
  displayedColumns = ["name", "actions"];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  pageable: Pageable2 = new Pageable2();
  paginatorConfig: PaginatorConfig;

  constructor(
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private genericErrorModalService: GenericErrorModalService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.paginatorConfig = new PaginatorConfig();
    this.pageable = {
      pageable: {
        pageNum: this.paginatorConfig.getPageNum(),
        pageSize: this.paginatorConfig.getPageSize(),
      },
      sort: {
        column: this.paginatorConfig.getFilterColumn(),
        direction: this.paginatorConfig.getFilterDirection(),
      },
      filter: {
        columns: ["subject", "content"],
        value: "",
      },
    };
    if (sessionStorage.getItem("latestFilterValueAreas") != null) {
      this.filterValue = sessionStorage.getItem("latestFilterValueAreas");
      this.pageable.filter.value = this.filterValue;
      this.dataSource.filter = this.filterValue.trim().toLowerCase();
    }
    this.getAreas();
  }

  getAreas() {
    this.loading = true;
    this.adminService.getAllAreas().subscribe(
      (value) => {
        this.loading = false;
        if (value.length == 0) this.emptyList = true;
        //this.dataSource = new MatTableDataSource<any>();
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case "name": {
              return item.areaName.toLowerCase();
            }
            default: {
              return item[property];
            }
          }
        };
        this.dataSource.data = value;
      },
      (error) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista delle aree",
          error
        );
      }
    );
  }

  newAreaByGeometry() {
    this.router.navigate(["insert"], { relativeTo: this.route });
  }

  newAreaByGeojson() {
    const dialogRef = this.dialog.open(AreaInsertByGeoJsonComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let areaInsertByGeoJsonRequest: AreaInsertByGeojsonRequest;
        areaInsertByGeoJsonRequest = {
          areaName: result.areaName,
          geoArea: JSON.parse(result.geoArea),
        };
        this.sub = true;
        this.adminService
          .insertAreaByGeojson(areaInsertByGeoJsonRequest)
          .subscribe(
            (res) => {
              this.sub = false;
              this.getAreas(); // Riottiene le aree compreso il nuovo inserimento
              this.openSnackBar("Area inserita con successo.", "Chiudi");
            },
            (err) => {
              console.error("Errore nell'inserimento dell'Area.", err);
              this.genericErrorModalService.open(
                "Errore durante l'inserimento dell'Area",
                err
              );
              this.sub = false;
            }
          );
      }
    });
  }

  onMapPreview(area) {
    let dialogRef;
    this.loading = true;
    this.adminService.getAreaDetail(area.id).subscribe(
      (response) => {
        this.loading = false;
        dialogRef = this.dialog.open(AreaMapDialogComponent, {
          data: {
            object: response.object,
          },
        });
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore durante il caricamento dell'Area ",
          err
        );
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }

  onFilterClear() {
    this.filterValue = "";
  }

  onFiltering() {
    this.pageable.filter.value = this.filterValue;
    sessionStorage.setItem("latestFilterValueAreas", this.filterValue);
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
    // this.getAreas();
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue.length == 0 || this.filterValue.length > 3) {
        this.pageable.filter.value = this.filterValue;
        sessionStorage.setItem("latestFilterValueAreas", this.filterValue);
        this.dataSource.filter = this.filterValue.trim().toLowerCase();
        // this.getAreas();
      }
    }
  }
}
